import React, { PropsWithChildren } from "react";

import { Label } from "@fronterahealth/frontera-ui-components";

interface CardContainerProps extends PropsWithChildren {
  title: string;
}

export const CardContainer: React.FC<CardContainerProps> = ({ children, title }) => {
  return (
    <div className="flex flex-col gap-4 border border-limestone-100 p-8 rounded-lg bg-white">
      <Label size="large" displayType="loud" colorType="primary">
        {title}
      </Label>
      {children}
    </div>
  );
};
